import React from 'react';
import styles from './CloseXButton.module.css';

interface Props {
  onClick: () => void;
  className?: string;
}
const CloseXButton = ({onClick, className}: Props) => {
  return (
    <div
      className={`${className ? className : ''} ${styles.closeXButton}`}
      onClick={onClick}
      role="button"
      aria-label="Close">
      {/* purely visual, no extra content needed */}
    </div>
  );
};

export default CloseXButton;
